import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-upload",
  "use": "icon-upload-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-upload\"><path d=\"M864 352H640v64h160v448H224V416h160v-64H160v576h704V352z\" fill=\"\" p-id=\"4181\" /><path d=\"M544 672V219.84l64.64 64 45.6-45.28-140.96-141.12-141.28 141.12 44.64 45.28 63.36-64V672h64z\" fill=\"\" p-id=\"4182\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol